import { FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage } from '@mui/icons-material'
import { TablePagination } from '@mui/material'
import { ChangeEvent } from 'react'

import { PaginationProps } from './types'

export const Pagination = ({
  count,
  page,
  rowsPerPage,
  rowsPerPageOptions,
  setPage,
  setRowsPerPage,
}: PaginationProps): React.JSX.Element => (
  <TablePagination
    count={count}
    onPageChange={(_, newPage: number): void => setPage(newPage + 1)}
    onRowsPerPageChange={(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
      setPage(1)
      setRowsPerPage(Number(event.target.value))
    }}
    page={page - 1} // MUI page prop starts at 0 while in our API from 1
    rowsPerPage={rowsPerPage}
    rowsPerPageOptions={rowsPerPageOptions}
    showFirstButton
    showLastButton
    slots={{
      actions: {
        firstButtonIcon: props => (
          <FirstPage
            {...props}
            data-cy='first-page-icon'
          />
        ),
        lastButtonIcon: props => (
          <LastPage
            {...props}
            data-cy='last-page-icon'
          />
        ),
        nextButtonIcon: props => (
          <KeyboardArrowRight
            {...props}
            data-cy='keyboard-arrow-right-icon'
          />
        ),
        previousButtonIcon: props => (
          <KeyboardArrowLeft
            {...props}
            data-cy='keyboard-arrow-left-icon'
          />
        ),
      },
    }}
    sx={{ marginLeft: 'auto' }}
  />
)
